<template>
  <div class="main-content">
    <!-- 检索过滤区域 -->
    <div class="search-wrapper marginBottom20">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <!-- <el-form-item label="分类名称 :">
          <el-input
            v-model="searchData.name"
            placeholder="请输入分类名称"
            clearable
            maxlength="20"
            style="width: 300px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearch"
          >
            搜索
          </el-button>
          <el-button size="medium" icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button> -->
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="handleCreate"
          >
            新增分类
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 树型结构数据表格 (支持同级拖拽排序) -->
    <div class="table-container" v-loading="showLoading">
      <!-- 搜索状态提示 -->
      <div v-if="searchData.name" class="drag-tip-bar">
        <i class="el-icon-info"></i>
        当前为检索过滤状态，暂不支持拖拽排序。清空搜索条件后可进行拖拽排序。
      </div>

      <!-- 表头 -->
      <div class="tree-table-header">
        <div class="header-col col-drag">排序</div>
        <div class="header-col col-name">分类名称</div>
        <div class="header-col col-level">层级</div>
        <div class="header-col col-parent">上级分类</div>
        <div class="header-col col-state">启用状态</div>
        <div class="header-col col-time">创建时间</div>
        <div class="header-col col-action">操作</div>
      </div>

      <!-- 树形可拖拽数据列表 -->
      <el-tree
        ref="classifyTree"
        :data="displayTableData"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        draggable
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
        @node-drop="handleNodeDrop"
        class="custom-tree-table"
      >
        <div slot-scope="{ node, data }" class="tree-row-content">
          <!-- 拖拽图标 -->
          <div class="tree-col col-drag" @click.stop>
            <i
              class="el-icon-rank drag-icon"
              :class="{ 'is-disabled': searchData.name }"
              :title="
                searchData.name ? '搜索状态下不可拖拽' : '按住拖拽调整同级排序'
              "
            ></i>
          </div>
          <!-- 分类名称 -->
          <div class="tree-col col-name">
            <span class="classify-name">{{ data.name }}</span>
          </div>
          <!-- 层级 -->
          <div class="tree-col col-level">
            <el-tag
              v-if="data.level === 1"
              size="small"
              effect="light"
              class="level-tag level-1"
            >
              一级
            </el-tag>
            <el-tag
              v-else-if="data.level === 2"
              size="small"
              effect="light"
              type="warning"
              class="level-tag level-2"
            >
              二级
            </el-tag>
            <el-tag
              v-else-if="data.level === 3"
              size="small"
              effect="light"
              type="success"
              class="level-tag level-3"
            >
              三级
            </el-tag>
            <el-tag v-else size="small" effect="light" class="level-tag">
              -
            </el-tag>
          </div>
          <!-- 上级分类 -->
          <div class="tree-col col-parent">
            <span>{{ data.parentName || "-" }}</span>
          </div>
          <!-- 启用状态 -->
          <div class="tree-col col-state" @click.stop>
            <el-switch
              v-model="data.state"
              :active-value="1"
              :inactive-value="2"
              @change="handleStateChange(data)"
            ></el-switch>
          </div>
          <!-- 创建时间 -->
          <div class="tree-col col-time">
            <span>{{ formatTime(data.createTime) }}</span>
          </div>
          <!-- 操作按钮列 -->
          <div class="tree-col col-action" @click.stop>
            <el-button
              v-if="data.level === 1 || data.level === 2"
              type="text"
              size="small"
              class="action-btn btn-add-sub"
              @click.stop="handleCreateSub(data)"
            >
              新增
            </el-button>
            <el-button
              type="text"
              size="small"
              class="action-btn btn-edit"
              @click.stop="handleEdit(data)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              class="action-btn btn-delete"
              @click.stop="handleDelete(data)"
            >
              删除
            </el-button>
          </div>
        </div>
      </el-tree>
    </div>

    <!-- 新增/修改弹窗 -->
    <el-dialog
      v-if="dialogVisible"
      :title="form.id ? '编辑课程分类' : '新增课程分类'"
      :visible.sync="dialogVisible"
      width="480px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="classify-dialog"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="formRules"
        label-width="90px"
        size="medium"
        style="padding: 0 10px"
      >
        <!-- 上级分类 -->
        <el-form-item label="上级分类" prop="parentId">
          <el-select
            v-model="form.parentId"
            placeholder="请选择上级分类"
            style="width: 100%"
            filterable
            :disabled="
              isParentDisabled || (form.id ? isOriginalParent(form.id) : false)
            "
          >
            <el-option label="无（作为一级分类）" value="0"></el-option>
            <el-option
              v-for="item in parentOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <div
                :style="{ paddingLeft: item.level === 2 ? '30px' : '20px' }"
                class="classify-select-item"
              >
                <el-tag
                  :type="item.level === 1 ? 'primary' : 'warning'"
                  size="mini"
                  style="margin-right: 8px; font-weight: 500"
                  effect="light"
                >
                  {{ item.level === 1 ? "一级" : "二级" }}
                </el-tag>
                <span class="classify-select-name">{{ item.name }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 分类名称 -->
        <el-form-item label="分类名称" prop="name">
          <el-input
            v-model="form.name"
            maxlength="20"
            placeholder="请输入分类名称（限制长度20）"
            clearable
            show-word-limit
          ></el-input>
        </el-form-item>

        <!-- 启用状态 -->
        <el-form-item label="启用状态" prop="state">
          <el-radio-group v-model="form.state">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <!-- 弹窗底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="submit"
          :loading="showLoadingForm"
          size="medium"
          class="btn-submit"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  courseClassifyListAll,
  courseClassifyAdd,
  courseClassifyUpdate,
  courseClassifyDelete,
  courseClassifyStateUpdate,
  courseClassifyTreeBatchUpdate,
} from "@/api/course/classify";

export default {
  name: "CourseClassify",
  data() {
    return {
      searchData: {
        name: "",
      },
      classifyTreeData: [], // 原始全量树状分类数据
      allClassifyList: [], // 全量打平的分类列表，用于上级分类查找翻译和校验
      showLoading: false,
      showLoadingForm: false, // 提交防抖
      dialogVisible: false,
      isParentDisabled: false, // 是否禁用上级分类选择（快捷新增下级分类时使用）
      form: {
        id: "",
        name: "",
        parentId: "0",
        state: 1,
      },
      formRules: {
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          { max: 20, message: "分类名称不能超过 20 个字符", trigger: "blur" },
        ],
        parentId: [
          { required: true, message: "请选择上级分类", trigger: "change" },
        ],
        state: [
          { required: true, message: "请选择启用状态", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    // 弹窗中可选择的“上级分类”下拉列表：只能选择一级和二级分类，且需排除当前编辑的分类本身及其子孙节点以防止环路
    parentOptions() {
      const descendants = this.form.id ? this.getDescendants(this.form.id) : [];
      return this.allClassifyList.filter((item) => {
        const isValidLevel = item.level === 1 || item.level === 2;
        const isNotSelf = !this.form.id || item.id !== this.form.id;
        const isNotDescendant = !this.form.id || !descendants.includes(item.id);
        return isValidLevel && isNotSelf && isNotDescendant;
      });
    },

    // 前端计算过滤展示的树结构，实现极速实时过滤检索
    displayTableData() {
      return this.filterTree(this.classifyTreeData, this.searchData.name);
    },
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      this.onLoad();
    },

    /**
     * 递归为树结构中的每个节点赋予 level（层级）属性
     * @param {Array} treeData - 树形结构数据
     * @param {number} [level=1] - 当前层级，默认为 1
     * @returns {Array} 赋予层级属性后的树形结构数据
     */
    addLevelToTree(treeData, level = 1) {
      const traverse = (node, currentLevel) => {
        node.level = currentLevel;
        if (Array.isArray(node.children) && node.children.length > 0) {
          node.children.forEach((child) => traverse(child, currentLevel + 1));
        }
      };
      treeData.forEach((node) => traverse(node, level));
      return treeData;
    },

    // 分页加载列表（直接使用 ListAll 接口拉取树状结构）
    onLoad() {
      this.showLoading = true;
      courseClassifyListAll()
        .then((res) => {
          this.showLoading = false;
          if (res.code === 200 && Array.isArray(res.data)) {
            this.classifyTreeData = this.addLevelToTree(res.data);
            this.allClassifyList = this.flattenTree(this.classifyTreeData);
          }
        })
        .catch(() => {
          this.showLoading = false;
        });
    },

    // 前端本地树形检索过滤
    filterTree(tree, name) {
      if (!name || !name.trim()) return tree;
      const filterNode = (node) => {
        let matchChildren = [];
        if (Array.isArray(node.children) && node.children.length > 0) {
          matchChildren = node.children.map(filterNode).filter(Boolean);
        }
        const isNameMatch = node.name
          .toLowerCase()
          .includes(name.trim().toLowerCase());
        if (isNameMatch || matchChildren.length > 0) {
          return {
            ...node,
            children: matchChildren,
          };
        }
        return null;
      };
      return tree.map(filterNode).filter(Boolean);
    },

    /**
     * 将嵌套树状结构打平（用于弹窗表单校验和选择列表，保留层级及父级名称）
     * @param {Array} treeData - 树形结构数据
     * @returns {Array} 打平后的扁平数组列表
     */
    flattenTree(treeData) {
      const result = [];
      const traverse = (node) => {
        result.push({
          id: node.id,
          name: node.name,
          parentId: node.parentId,
          state: node.state,
          level: node.level,
          parentName: node.parentName,
        });
        if (Array.isArray(node.children) && node.children.length > 0) {
          node.children.forEach(traverse);
        }
      };
      treeData.forEach(traverse);
      return result;
    },

    /**
     * 递归获取指定分类节点的所有子孙节点的 ID
     * @param {string|number} id - 分类 ID
     * @returns {Array<string|number>} 子孙节点的 ID 集合
     */
    getDescendants(id) {
      if (!id) return [];
      const list = [];
      const find = (parentId) => {
        this.allClassifyList.forEach((item) => {
          if (item.parentId === parentId) {
            list.push(item.id);
            find(item.id);
          }
        });
      };
      find(id);
      return list;
    },

    /**
     * 树节点拖拽放落判定规则：限制只能同级同父节点拖拽排序，不可跨级，不可改变归属
     * @param {Object} draggingNode - 被拖拽节点
     * @param {Object} dropNode - 放置目标节点
     * @param {string} type - 放置类型 ('prev' | 'inner' | 'next')
     * @returns {boolean} 是否允许放落
     */
    allowDrop(draggingNode, dropNode, type) {
      // 1. 不能放落为 inner (禁止将节点拖入内部变成子节点，避免改变层级与父节点)
      if (type === "inner") {
        return false;
      }
      // 2. 目标节点与被拖拽节点必须处在相同的层级 (level 相同)
      if (draggingNode.data.level !== dropNode.data.level) {
        return false;
      }
      // 3. 目标节点与被拖拽节点必须属于同一个父节点 (parentId 相同)
      const draggingParentId = String(draggingNode.data.parentId || "0");
      const dropParentId = String(dropNode.data.parentId || "0");
      if (draggingParentId !== dropParentId) {
        return false;
      }
      return true;
    },

    /**
     * 判定节点是否开启拖拽
     * @param {Object} node - 树节点
     * @returns {boolean} 是否允许拖拽
     */
    allowDrag(node) {
      // 当有搜索关键词检索过滤时，禁止拖拽排序
      if (this.searchData.name && this.searchData.name.trim() !== "") {
        return false;
      }
      return true;
    },

    /**
     * 递归构建接口所需的 treeList 节点数据，并更新节点的 sort 值（排序值越大越靠前）
     * @param {Array} list - 树形分类节点列表
     * @returns {Array} 符合 WebCourseClassifyTreeBatchUpdateDTO[] 结构的数组
     */
    buildTreeListPayload(list) {
      if (!Array.isArray(list) || list.length === 0) return [];
      const len = list.length;
      return list.map((item, index) => {
        // 同级列表中，排在越靠前 (index越小) 的节点 sort 排序值赋予越大 (步长为1: len, len-1, len-2...)
        const sortVal = len - index;
        item.sort = sortVal;
        return {
          id: String(item.id),
          name: item.name || "",
          sort: sortVal,
          children: Array.isArray(item.children)
            ? this.buildTreeListPayload(item.children)
            : [],
        };
      });
    },

    /**
     * 节点拖拽成功完成后的回调事件，组装数据提交接口 course/classify/tree/batchUpdate
     * @param {Object} draggingNode - 被拖拽节点对象
     * @param {Object} dropNode - 目标放落节点对象
     * @param {string} dropType - 放置位置 ('before' | 'after')
     * @param {Event} ev - 拖拽 Event 事件
     */
    handleNodeDrop(draggingNode, dropNode, dropType, ev) {
      // 构建完整树排序 DTO 数据
      const treeListPayload = this.buildTreeListPayload(this.classifyTreeData);

      this.showLoading = true;
      courseClassifyTreeBatchUpdate({ treeList: treeListPayload })
        .then((res) => {
          this.showLoading = false;
          if (res.code === 200) {
            this.$message.success("排序调整成功");
            this.onLoad(); // 刷新获取最新数据
          } else {
            this.$message.error(res.message || "排序调整失败");
            this.onLoad();
          }
        })
        .catch(() => {
          this.showLoading = false;
          this.onLoad();
        });
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return "-";
      try {
        const date = new Date(time);
        if (isNaN(date.getTime())) return time;
        const pad = (num) => String(num).padStart(2, "0");
        const y = date.getFullYear();
        const m = pad(date.getMonth() + 1);
        const d = pad(date.getDate());
        const h = pad(date.getHours());
        const min = pad(date.getMinutes());
        return `${y}-${m}-${d} ${h}:${min}`;
      } catch (e) {
        return time;
      }
    },

    // 搜索
    handleSearch() {
      // displayTableData 计算属性会自动感应 searchData.name 改变
    },

    // 重置
    handleReset() {
      this.searchData.name = "";
    },

    // 快捷切换启用/下架状态
    handleStateChange(row) {
      const originalState = row.state === 1 ? 2 : 1;
      const stateText = row.state === 1 ? "上架" : "下架";

      courseClassifyStateUpdate({
        id: row.id,
        state: row.state,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`已成功将分类【${row.name}】${stateText}`);
            this.onLoad(); // 重新加载全量树结构
          } else {
            row.state = originalState;
          }
        })
        .catch(() => {
          row.state = originalState;
        });
    },

    // 判断该分类编辑前是否是一级分类
    isOriginalParent(id) {
      const original = this.allClassifyList.find((item) => item.id === id);
      return original ? !original.parentId || original.parentId === "0" : false;
    },

    // 新增按钮点击
    handleCreate() {
      this.form = {
        id: "",
        name: "",
        parentId: "0",
        state: 1,
      };
      this.isParentDisabled = false;
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    /**
     * 列表操作栏快捷“新增”下级分类点击事件
     * @param {Object} row - 当前行分类数据对象
     */
    handleCreateSub(row) {
      this.form = {
        id: "",
        name: "",
        parentId: row.id,
        state: 1,
      };
      this.isParentDisabled = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 编辑按钮点击
    handleEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        parentId: row.parentId || "0",
        state: row.state,
      };
      this.isParentDisabled = false;
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 删除按钮点击
    handleDelete(row) {
      this.$confirm(`此操作将永久删除分类【${row.name}】, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          courseClassifyDelete(row.id).then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.onLoad(); // 重新加载树结构
            }
          });
        })
        .catch(() => {});
    },

    // 关闭弹窗并重置表单
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        id: "",
        name: "",
        parentId: "0",
        state: 1,
      };
      this.isParentDisabled = false;
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },

    // 提交新增/修改表单
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.showLoadingForm) return;
          this.showLoadingForm = true;

          // 整理提交数据，若 parentId 为空则默认传 "0" 代表顶级分类
          const submitData = {
            ...this.form,
            name: this.form.name.trim(),
            parentId: this.form.parentId || "0",
          };

          const requestApi = submitData.id
            ? courseClassifyUpdate
            : courseClassifyAdd;

          requestApi(submitData)
            .then((res) => {
              this.showLoadingForm = false;
              if (res.code === 200) {
                this.$message.success("操作成功");
                this.dialogVisible = false;
                this.onLoad(); // 重新加载树结构
              }
            })
            .catch(() => {
              this.showLoadingForm = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.main-content {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 100px);
}

.search-wrapper {
  padding: 10px 0;
}

/* 树形表格容器 */
.table-container {
  margin-top: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #ffffff;
  overflow: hidden;
}

.drag-tip-bar {
  background-color: #e6f7ff;
  border-bottom: 1px solid #91d5ff;
  color: #1890ff;
  padding: 8px 16px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 表格头部 */
.tree-table-header {
  display: flex;
  align-items: center;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
  color: #606266;
  font-size: 14px;
  height: 48px;
  padding: 0 10px;
}

.header-col {
  text-align: center;
  padding: 0 8px;
  box-sizing: border-box;
}

/* 树结构行样式覆盖 */
.custom-tree-table >>> .el-tree-node__content {
  height: 48px;
  border-bottom: 1px solid #ebeef5;
  transition: background-color 0.2s;
}

.custom-tree-table >>> .el-tree-node__content:hover {
  background-color: #f5f7fa;
}

.tree-row-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #606266;
}

.tree-col {
  text-align: center;
  padding: 0 8px;
  box-sizing: border-box;
}

/* 列宽度分配 */
.col-drag {
  width: 60px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.col-name {
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-level {
  width: 100px;
  flex-shrink: 0;
}

.col-parent {
  width: 140px;
  flex-shrink: 0;
}

.col-state {
  width: 100px;
  flex-shrink: 0;
}

.col-time {
  width: 180px;
  flex-shrink: 0;
}

.col-action {
  width: 180px;
  flex-shrink: 0;
}

/* 拖拽手柄图标 */
.drag-icon {
  font-size: 18px;
  color: #909399;
  cursor: grab;
  padding: 4px;
  transition: color 0.2s, transform 0.2s;
}

.drag-icon:hover {
  color: #409eff;
  transform: scale(1.15);
}

.drag-icon:active {
  cursor: grabbing;
}

.drag-icon.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.classify-name {
  font-weight: 500;
  color: #333333;
}

/* 标签样式 */
.level-tag {
  font-weight: 500;
  border-radius: 4px;
  padding: 0 10px;
}
.level-1 {
  background-color: #ecf5ff !important;
  color: #409eff !important;
  border-color: #d9ecff !important;
}
.level-2 {
  background-color: #fdf6ec !important;
  color: #e6a23c !important;
  border-color: #faecd8 !important;
}
.level-3 {
  background-color: #f0f9eb !important;
  color: #67c23a !important;
  border-color: #e1f3d8 !important;
}

/* 操作列按钮样式 */
.action-btn {
  font-weight: 500;
  font-size: 14px;
  margin: 0 10px;
  padding: 0;
  border: none;
}

.btn-delete {
  color: #ff001f !important;
}
.btn-delete:hover {
  color: #cc0018 !important;
  text-decoration: underline;
}

.dialog-footer {
  text-align: right;
}

/* 间距工具类 */
.marginBottom20 {
  margin-bottom: 20px;
}
.marginTop20 {
  margin-top: 20px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.justify-end {
  justify-content: flex-end;
}
.align-items {
  align-items: center;
}

/* 自定义下拉框选项样式 */
.classify-select-item {
  display: flex;
  align-items: center;
  height: 100%;
}
.classify-select-name {
  font-size: 14px;
}
</style>
